import Arrow from "@components/icons/Arrow";
import { JSON_SCHEMAS } from "@components/utils/constants";
import JsonLdSchema from "@libs/schema/JsonLdSchema";
import { useMemo } from "react";
import BreadcrumbContainer from "./components/BreadcrumbContainer";
import BreadcrumbItem from "./components/BreadcrumbItem";
import { breadcrumbObjectFromURL } from "./utils/breadcrumbHelpers";

const Breadcrumb = (): JSX.Element => {
  const breadcrumbObjects = breadcrumbObjectFromURL();

  const breadcrumbs: JSX.Element[] = useMemo(() => {
    return breadcrumbObjects.map((objectItem, index) => {
      const isLastItem = index === breadcrumbObjects.length - 1;
      return (
        <li className="flex flex-row gap-2" key={index}>
          <BreadcrumbItem
            label={objectItem.label}
            href={objectItem.link}
            isCurrentPage={isLastItem}
          />
          {!isLastItem && <Arrow direction="right" size="small" />}
        </li>
      );
    });
  }, [breadcrumbObjects]);

  return (
    <>
      <JsonLdSchema
        data={{ breadcrumbObjects }}
        type={JSON_SCHEMAS.BREADCRUMB}
      />
      <BreadcrumbContainer>{breadcrumbs}</BreadcrumbContainer>
    </>
  );
};

export default Breadcrumb;
